import ProportionalChart from './ProportionalChart';
export default ProportionalChart;
